interface PickerOptionsObject {
  disabledDate: (time: { getTime: () => number }) => boolean;
}

const disableDates = {
  oneDayInMilliseconds: 24 * 60 * 60_000,

  inThePast: {
    disabledDate: (time) => time.getTime() < Date.now() - disableDates.oneDayInMilliseconds,
  } as PickerOptionsObject,

  inThePastAndAfterProjectDeadline: (projectDeadline: string): PickerOptionsObject => ({
    disabledDate: (time) =>
      time.getTime() < Date.now() - disableDates.oneDayInMilliseconds ||
      time.getTime() > Date.parse(projectDeadline.toString()),
  }),

  inTheFuture: {
    disabledDate: (time) => time.getTime() > Date.now(),
  } as PickerOptionsObject,

  inTheFutureAndBeforePositionStart: (start: string): PickerOptionsObject => ({
    disabledDate: (time) => {
      const disableDatesBeforeStart = start ? time.getTime() <= Date.parse(start) : true;

      return time.getTime() > Date.now() || disableDatesBeforeStart;
    },
  }),

  beforeCurrentDeadline: (currentProjectDeadline: number): PickerOptionsObject => ({
    disabledDate: (time) => time.getTime() < currentProjectDeadline,
  }),

  beforeEducationStart: (start: string): PickerOptionsObject => ({
    disabledDate: (time) => {
      return time.getTime() <= Date.parse(start);
    },
  }),
};

export default disableDates;
